import { Action, createReducer, on } from '@ngrx/store';
import * as QuickbooksActions from '../actions/quickbooks.actions';

export const quickbooksFeatureKey = 'quickbooks';

export interface State {
  syncs: any[]
}

export const initialState: State = {
  syncs: null
};

export const reducer = createReducer(
  initialState,

  on(QuickbooksActions.loadQuickbooks, state => state),
  on(QuickbooksActions.loadQuickbooksSuccess, (state, action) => state),
  on(QuickbooksActions.loadQuickbooksFailure, (state, action) => state),
  on(QuickbooksActions.loadSyncsSuccess, (state, action) => ({
    syncs: action.payload
  })),
  on(QuickbooksActions.addSync, (state, action) => ({
    syncs: [action.sync, ...state.syncs]
  })),
);
